import { activityService } from '../services/activityService';

export function buildLeadActivitySummary(leadId, limit = 8) {
  const acts = activityService.getForLead(leadId).slice(0, limit);
  return acts.map(a => {
    const when = a.date && a.time ? `${a.date} ${a.time}` : (a.ts ? new Date(a.ts).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');
    const title = a.title || a.type || 'Aktivität';
    const note = a.note ? ` – ${String(a.note).slice(0, 120)}` : '';
    const by = a.by ? ` (${a.by})` : '';
    return `• ${when ? `${when}: ` : ''}${title}${note}${by}`.trim();
  });
}

export function buildHandoffNotes(message, leadId) {
  const summary = buildLeadActivitySummary(leadId, 10);
  const lines = [message.trim()];
  if (summary.length) {
    lines.push('', '--- Aktivitäts-Verlauf (letzte Einträge) ---', ...summary);
  }
  return lines.join('\n');
}

export function addWorkdays(start, n) {
  const d = new Date(start);
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) added++;
  }
  return d;
}
